// extracted by mini-css-extract-plugin
export default {"cls1":"ModalError-cls1___bb5689edf63fcceb5e8","cls2":"ModalError-cls2__e48bb9218b4e3a7970a6 ModalError-cls1___bb5689edf63fcceb5e8"};